export default __webpack_public_path__ + "static/media/download.b127db2e.svg";